.walkthrough-page {
  min-height: 100vh;
  background-color: var(--color-background);
}

.walkthrough-hero {
  background: linear-gradient(135deg, var(--color-primary-dark) 0%, var(--color-primary) 100%);
  color: white;
  padding: 140px 0 60px;
}

.walkthrough-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.walkthrough-back-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-weight: 500;
  margin-bottom: 32px;
  transition: color 0.2s ease;
}

.walkthrough-back-link:hover {
  color: white;
}

.walkthrough-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.walkthrough-icon-wrapper {
  background: rgba(255, 255, 255, 0.1);
  padding: 20px;
  border-radius: 24px;
  backdrop-filter: blur(10px);
  margin-bottom: 24px;
  color: white;
}

.walkthrough-header h1 {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 1.2;
}

.walkthrough-subtitle {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.9);
  max-width: 600px;
}

.walkthrough-content {
  padding: 80px 0;
}

.walkthrough-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 48px;
  align-items: start;
}

@media (min-width: 1024px) {
  .walkthrough-grid {
    grid-template-columns: 350px 1fr;
  }
}

.walkthrough-info h2 {
  font-size: 1.75rem;
  color: var(--color-text);
  margin-bottom: 16px;
}

.walkthrough-description {
  font-size: 1.1rem;
  color: var(--color-text-light);
  line-height: 1.6;
  margin-bottom: 40px;
}

.walkthrough-highlights h3 {
  font-size: 1.25rem;
  color: var(--color-text);
  margin-bottom: 20px;
}

.walkthrough-highlights ul {
  list-style: none;
  padding: 0;
  margin: 0 0 40px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.walkthrough-highlights li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 1rem;
  color: var(--color-text-light);
  line-height: 1.5;
}

.highlight-icon {
  color: var(--color-primary);
  flex-shrink: 0;
  margin-top: 2px;
}

.walkthrough-cta {
  background: white;
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.walkthrough-cta p {
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 16px;
}

.walkthrough-btn-primary {
  display: block;
  background: var(--color-primary);
  color: white;
  text-decoration: none;
  padding: 14px 24px;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.walkthrough-btn-primary:hover {
  background: var(--color-primary-dark);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
}

.walkthrough-video-wrapper {
  perspective: 1000px;
}

.walkthrough-browser-mockup {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.1);
  transform-origin: top center;
  transition: transform 0.3s ease;
}

.browser-header {
  background: #f1f5f9;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.browser-dots {
  display: flex;
  gap: 8px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.dot.red { background: #ef4444; }
.dot.yellow { background: #f59e0b; }
.dot.green { background: #10b981; }

.browser-address-bar {
  flex: 1;
  background: white;
  padding: 6px 16px;
  border-radius: 6px;
  font-size: 0.85rem;
  color: #64748b;
  text-align: center;
  border: 1px solid #e2e8f0;
  font-family: monospace;
}

.browser-content {
  background: #f8fafc;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.walkthrough-video {
  width: 100%;
  height: auto;
  display: block;
}

@media (max-width: 768px) {
  .walkthrough-header h1 {
    font-size: 2.25rem;
  }
  
  .walkthrough-content {
    padding: 48px 0;
  }
}
